import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=48afac74&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=js&"
export * from "./ReportHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afac74",
  null
  
)

export default component.exports